// 社員新規作成・編集画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Checkbox
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import HelpIcon from '@material-ui/icons/Help';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './List.css';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import 'date-fns';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  furiganaRegex,
  invalidPhoneNumberRegex,
  userRole,
  userTenant
} from '../GlobalState';
import {
  createEmployeeMaster,
  getEmployeeMasterDetailsById,
  editEmployeeMaster,
  deleteEmployeeMasterById,
  getEmployeeMasterRoles,
  getUserPermission,
  saveEmployeeBasic,
  addFacePhoto,
  getFacePhoto,
  deleteFacePhoto
} from '../apicalls/employeeMaster';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { getEmployeeGroups } from '../apicalls/employeeGroup';
import { NotFoundPage } from './NotFoundPage';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { getVendorList } from '../apicalls/getVendorDetails';
import SearchIcon from '@material-ui/icons/Search';
import { EMPLOYEE_TYPE } from '../const/Const';
import { DatePickerInput } from '../components/atoms';
import { format, parse } from 'date-fns';
import { EMPLOYEE_ADD_INFO_TENANT_IDS } from '../const/Const';
import { TTenant } from '../types/common';

export const CreateEmployeeMaster: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission, setUserPermission] = useRecoilState(userRole);
  const [isFurigana] = useRecoilState(furiganaRegex);
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [companyGroups, setCompanyGroups] = useState([]);

  const [name, setName] = useState('');
  const [furigana, setFurigana] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [phone, setPhone] = useState('');
  const [selectedGroupId, setSelectedGroupId] = useState<number[]>([]);
  const [selectedGroupIdNames, setSelectedGroupIdNames] = useState<any[]>([]);
  const [enrollmentStatus, setEnrollmentStatus] = useState<number>(0);
  const [department, setDepartment] = useState('');
  const [occupation, setOccupation] = useState('');
  const [position, setPosition] = useState('');
  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(true);
  const [employeeMasterRoles, setEmployeeMasterRoles] = useState<any[]>([]);
  const [vendorData, setVendorData] = useState([]);
  const [vendorDataSearch, setVendorDataSearch] = useState([]);
  const [selectVendorModal, setSelectVendorModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(true);
  const [employeePostalCode, setEmployeePostalCode] = useState(''); //郵便番号
  const [firstPart, setFirstPart] = useState('');
  const [secondPart, setSecondPart] = useState('');
  const [employeeAddress, setEmployeeAddress] = useState(''); //住所
  const [employeeNum, setEmployeeNum] = useState(''); //社員ID
  const [othersDepartment, setOthersDepartment] = useState(''); //所属
  const [experienceStartDate, setExperienceStartDate] =
    useState<string | null>(null); //経験開始年月日
  const [selectedExpStartDateValue, setSelectedExpStartDateValue] =
    useState<Date | null>(null);
  const [yearsOfExperience, setYearsOfExperience] = useState(''); //経験年数
  const [joinDate, setJoinDate] = useState<string | null>(null); //入社年月日
  const [selectedJoinDateValue, setSelectedJoinDateValue] =
    useState<Date | null>(null);
  const [yearsOfService, setYearsOfService] = useState(''); //在籍年数
  const [retirementDate, setRetirementDate] = useState<string | null>(null); //退職年月日
  const [selectedRetirementDateValue, setSelectedRetirementDateValue] =
    useState<Date | null>(null);
  const [dateOfBirth, setDateOfBirth] = useState<string | null>(null); //生年月日
  const [age, setAge] = useState('');
  const [selectedDateOfBirthValue, setSelectedDateOfBirthValue] =
    useState<Date | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [jobType, setJobType] = useState(''); //職種記号
  const [jobType1, setJobType1] = useState('');
  const [jobType2, setJobType2] = useState('');
  const [jobType3, setJobType3] = useState('');
  const [jobType4, setJobType4] = useState('');
  const [jobType5, setJobType5] = useState('');
  const [jobType6, setJobType6] = useState('');
  const [dependentFamily, setDependentFamily] = useState(false); //扶養家族
  const [numOfDependents, setNumOfDependents] = useState(''); //扶養人数
  const [facePhoto, setFacePhoto] = useState<string | null>(null); //顔写真
  const [facePhotoFormat, setFacePhotoFormat] = useState<string>('');

  //社員画面に社員の追加情報入力欄を表示する企業の判別
  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);
  const mode = (process.env.REACT_APP_MODE ||
    'dev') as keyof typeof EMPLOYEE_ADD_INFO_TENANT_IDS;
  const customerSpecificTenantIds = EMPLOYEE_ADD_INFO_TENANT_IDS[mode] || [];
  const isEmployeeAddInfo = userTenantData
    ? customerSpecificTenantIds.includes(userTenantData.id)
    : false;

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        width: matches2 ? 600 : '80%'
      },

      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputJobType: {
        height: 40,
        width: '15%',
        borderColor: '#c1c1c1',
        borderWidth: 1,
        textAlign: 'center'
      },
      inputJobTypeMainContainer: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputJobTypeContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        display: 'flex',
        flexDirection: 'row'
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        height: 60,
        maxHeight: 100,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      },
      topBoxText: {
        fontSize: 14,
        color: isCreateMode ? '#c1c1c1' : '#000000'
      },
      sealImage: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 140,
        alignItems: 'center',
        width: '100%'
      },
      sealtextContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 140,
        alignItems: 'center'
      }
    })
  );

  const history: any = useHistory();
  const location: any = useLocation();

  // 自社社員か社外パートナーか
  const employeeType: number = history.location.state.employeeType;
  // 編集か新規作成か
  const actionType: string = history.location.state.actionType;
  const isCreateMode = actionType === 'create';
  const isEditMode = actionType === 'edit';
  // 業者詳細画面から遷移した場合はパートナーIDのデフォルト値を設定する
  const selectedPartnerId: number = history.location.state.partnerId
    ? history.location.state.partnerId
    : 0;
  const [partnerId, setPartnerId] = useState<number>(selectedPartnerId);
  // 社外パートナーの場合は権限を４で固定する
  const [selectedEmployeeRole, setSelectedEmployeeRole] = useState<number>(
    employeeType === EMPLOYEE_TYPE['INSIDE_EMPLOYEE'] ? 0 : 4
  );
  // 社員ID
  const employeeId: number = history.location.state?.employeeId || 0;

  const classes = useStyles({ isCreateMode });

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const getAllCompanyGroups = () => {
    getEmployeeGroups().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCompanyGroups(data.data);
          }
        }
      }
    });
  };

  const getAllEmployeeMasterRoles = () => {
    getEmployeeMasterRoles().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEmployeeMasterRoles(data.data);
          }
        }
      }
    });
  };

  //日付変換
  const handleDate = (dateString: any, setParsedDate: any, setRawDate: any) => {
    if (dateString) {
      const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date());
      setParsedDate(parsedDate);
      setRawDate(dateString);
    } else {
      setParsedDate(null);
      setRawDate(null);
    }
  };

  const getAllDetailsOfEmployeeMasterById = () => {
    getEmployeeMasterDetailsById(employeeId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setName(data.data.name);
            setFurigana(data.data.furigana);
            setPhone(data.data.tel);
            setEmail(data.data.email);
            setEmployeePostalCode(data.data.employee_postal_code);
            setEmployeeAddress(data.data.employee_address);
            setDepartment(data.data.department);
            setOccupation(data.data.occupation);
            setPosition(data.data.position);
            setEnrollmentStatus(data.data.enrollment_status);
            setRemarks(data.data.remarks);
            setPartnerId(data.data.partner_id);
            setEmployeeNum(data.data.employee_id);
            setOthersDepartment(data.data.others_department);
            handleDate(
              data.data.experience_start_date,
              setSelectedExpStartDateValue,
              setExperienceStartDate
            );
            handleDate(
              data.data.join_date,
              setSelectedJoinDateValue,
              setJoinDate
            );
            handleDate(
              data.data.retirement_date,
              setSelectedRetirementDateValue,
              setRetirementDate
            );
            handleDate(
              data.data.date_of_birth,
              setSelectedDateOfBirthValue,
              setDateOfBirth
            );
            setJobType(data.data.job_type);
            const jobTypes = data.data.job_type.split('');
            setJobType1(jobTypes[0] || '');
            setJobType2(jobTypes[1] || '');
            setJobType3(jobTypes[2] || '');
            setJobType4(jobTypes[3] || '');
            setJobType5(jobTypes[4] || '');
            setJobType6(jobTypes[5] || '');
            setDependentFamily(data.data.dependent_family);
            setNumOfDependents(
              data.data.number_of_dependents
                ? data.data.number_of_dependents.toString()
                : ''
            );
            if (data.data.group_id !== '') {
              setSelectedGroupId(data.data.group_ids);
            }
            setSelectedGroupIdNames(data.data.group_names);
            if (data.data.role_id) {
              setSelectedEmployeeRole(data.data.role_id);
            }

            if (data.data.experience_start_date) {
              const experienceStartDate = parse(
                data.data.experience_start_date,
                'yyyy-MM-dd',
                new Date()
              );
              setYearsOfExperience(calculateYears(experienceStartDate));
            }
            if (data.data.join_date) {
              const joinDate = parse(
                data.data.join_date,
                'yyyy-MM-dd',
                new Date()
              );
              setYearsOfService(calculateYears(joinDate));
            }
            if (data.data.date_of_birth) {
              const dateOfBirth = parse(
                data.data.date_of_birth,
                'yyyy-MM-dd',
                new Date()
              );
              setSelectedDateOfBirthValue(dateOfBirth);
              setDateOfBirth(data.data.date_of_birth);
              setAge(calculateAge(dateOfBirth));
            }
            setLoading(false);
          }
        }
      }
    });
  };

  // 社員情報追加
  const saveEmployeeAdditionalInfo = (user_id: number) => {
    saveEmployeeBasic(
      user_id,
      employeeNum,
      employeePostalCode,
      employeeAddress,
      othersDepartment,
      experienceStartDate || '',
      joinDate || '',
      retirementDate || '',
      dateOfBirth || '',
      jobType,
      dependentFamily,
      Number(numOfDependents),
      isEdit
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
          }
        }
      }
    });
  };

  /**
   * 業者一覧取得
   */
  const getListOfVendors = useCallback(() => {
    getVendorList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setVendorData(data.data);
            setVendorDataSearch(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  useEffect(() => {
    getAllCompanyGroups();
    getAllEmployeeMasterRoles();
    getListOfVendors();
    if (isEditMode && employeeId) {
      getAllDetailsOfEmployeeMasterById();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const saveEmployeeMasterDetails = () => {
    if (name.trim() === '') {
      setErrorMessage('名前を入力してください。');
      setOpen(true);
    } else if (name.length > 20) {
      setErrorMessage('名前は20文字以内で入力してください。');
      setOpen(true);
    } else if (furigana.trim() !== '' && !isFurigana.test(furigana.trim())) {
      setErrorMessage('無効なふりがなです。');
      setOpen(true);
    } else if (email.trim() === '') {
      setErrorMessage('メールアドレスを入力してください。');
      setOpen(true);
    } else if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email.trim()
      )
    ) {
      setErrorMessage('メールアドレスの形式が正しくありません。');
      setOpen(true);
    } else if (password1.trim() === '') {
      setErrorMessage('パスワードを入力してください。');
      setOpen(true);
    } else if (password1.trim().length < 6) {
      setErrorMessage('パスワードは6文字以上入力して下さい');
      setOpen(true);
    } else if (phone.trim() !== '' && phone.trim().length > 60) {
      setErrorMessage('無効な電話番号です。');
      setOpen(true);
    } else if (enrollmentStatus === 0) {
      setErrorMessage('ステータスを入力してください。');
      setOpen(true);
    } else if (selectedEmployeeRole === 0) {
      setErrorMessage('権限を入力してください。');
      setOpen(true);
    } else {
      createEmployeeMaster(
        name.trim(),
        furigana.trim(),
        email.trim(),
        password1.trim(),
        phone.trim(),
        selectedGroupId,
        enrollmentStatus,
        department.trim(),
        occupation.trim(),
        position.trim(),
        remarks.trim(),
        selectedEmployeeRole,
        partnerId
      ).then(async data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              // employeeIdを更新
              const newEmployeeId = data.user_id;
              await saveEmployeeAdditionalInfo(newEmployeeId);
              setErrorMessage(data.message);
              setOpenSuccess(true);
              if (!isEmployeeAddInfo) {
                const timer = setTimeout(() => {
                  if (history.location.state?.partnerId) {
                    history.goBack();
                  } else {
                    history.push('/employee-masters', {
                      employeeType: employeeType
                    });
                  }
                }, 1500);
                return () => clearTimeout(timer);
              } else {
                // 新規作成後のリダイレクト処理
                const timer = setTimeout(() => {
                  // 編集画面にリダイレクト
                  history.push(`/employee-masters/${newEmployeeId}/edit`, {
                    employeeId: newEmployeeId,
                    actionType: 'edit',
                    employeeType: employeeType,
                    partnerId: partnerId
                  });
                  // 画面リロード
                  window.location.reload();
                }, 1500);
                return () => clearTimeout(timer);
              }
            }
          }
        }
      });
    }
  };

  const editEmployeeMasterDetails = async () => {
    if (name.trim() === '') {
      setErrorMessage('名前を入力してください。');
      setOpen(true);
      return;
    } else if (furigana.trim() !== '' && !isFurigana.test(furigana.trim())) {
      setErrorMessage('無効なふりがなです。');
      setOpen(true);
    } else if (phone.trim() !== '' && phone.trim().length > 60) {
      setErrorMessage('無効な電話番号です。');
      setOpen(true);
      return;
    } else if (enrollmentStatus === 0) {
      setErrorMessage('ステータスを入力してください。');
      setOpen(true);
      return;
    } else if (email.trim() === '') {
      setErrorMessage('メールアドレスを入力してください。');
      setOpen(true);
      return;
    } else if (
      !/^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email.trim()
      )
    ) {
      setErrorMessage('メールアドレスの形式が正しくありません。');
      setOpen(true);
      return;
    } else if (selectedEmployeeRole === 0) {
      setErrorMessage('権限を入力してください。');
      setOpen(true);
      return;
    }
    try {
      const response = await editEmployeeMaster(
        employeeId,
        name.trim(),
        furigana.trim(),
        email.trim(),
        phone.trim(),
        selectedGroupId,
        enrollmentStatus,
        department.trim(),
        occupation.trim(),
        position.trim(),
        remarks.trim(),
        selectedEmployeeRole,
        partnerId
      );

      if (response === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else if (typeof response === 'string' || response.error) {
        setErrorMessage(
          typeof response === 'string' ? response : response.error
        );
        setOpen(true);
      } else {
        await saveEmployeeAdditionalInfo(employeeId);
        setOpenSuccess(true);
        getUserRole();
        if (!isEmployeeAddInfo) {
          const timer = setTimeout(() => {
            // 業者詳細に戻る
            if (history.location.state?.partnerId) {
              history.goBack();
            } else {
              // 社外パートナー一覧に戻る
              history.push('/employee-masters', {
                employeeType: employeeType
              });
            }
          }, 1500);
          return () => clearTimeout(timer);
        }
      }
    } catch (error) {
      setErrorMessage('更新中にエラーが発生しました。');
      setOpen(true);
    }
  };

  const deleteEmployeeMasterDetailsById = () => {
    deleteEmployeeMasterById(employeeId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              // 業者詳細に戻る
              if (history.location.state.partnerId) {
                history.goBack();
              }
              // 社外パートナー一覧に戻る
              history.push('/employee-masters', {
                employeeType: employeeType
              });
            }, 1500);
          }
        }
      }
    });
  };

  const handleChange = (event: React.ChangeEvent<{ value: any }>, i: any) => {
    setSelectedGroupIdNames(event.target.value as string[]);
    if (selectedGroupId.includes(Number(i.key.split('$')[1]))) {
      var ind = selectedGroupId.indexOf(Number(i.key.split('$')[1]));
      if (ind !== -1) selectedGroupId.splice(ind, 1);
    } else {
      let newSelectedGroupId = selectedGroupId;
      newSelectedGroupId.push(Number(i.key.split('$')[1]));
      setSelectedGroupId(newSelectedGroupId);
    }
  };

  const getUserRole = () => {
    getUserPermission().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setUserPermission(data.role);
          }
        }
      }
    });
  };

  //経験開始年月日
  const handleExperienceStartDate = (date: Date | null) => {
    setSelectedExpStartDateValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setExperienceStartDate(formattedDate);
      setYearsOfExperience(calculateYears(date));
    } else {
      setExperienceStartDate(null);
      setYearsOfExperience('');
    }
  };

  //入社年月日
  const handleJoinDate = (date: Date | null) => {
    setSelectedJoinDateValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setJoinDate(formattedDate);
      setYearsOfService(calculateYears(date));
    } else {
      setJoinDate(null);
      setYearsOfService('');
    }
  };

  //退職年月日
  const handleRetirementDate = (date: Date | null) => {
    setSelectedRetirementDateValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setRetirementDate(formattedDate);
    } else {
      setRetirementDate(null);
    }
  };

  //生年月日
  const handleDateOfBirth = (date: Date | null) => {
    setSelectedDateOfBirthValue(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setDateOfBirth(formattedDate);
      setAge(calculateAge(date));
    } else {
      setDateOfBirth(null);
      setAge('');
    }
  };

  // 年齢計算
  const calculateAge = (birthDate: Date | null): string => {
    if (!birthDate) return '';
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age.toString();
  };

  // 年数計算
  const calculateYears = (startDate: Date | null): string => {
    if (!startDate) return '';
    const today = new Date();
    let years = today.getFullYear() - startDate.getFullYear();
    const monthDiff = today.getMonth() - startDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < startDate.getDate())
    ) {
      years--;
    }
    return years.toString();
  };

  // 職種記号の入力値を更新し、全体の値を結合
  const updateJobType = () => {
    const combinedJobType = [
      jobType1,
      jobType2,
      jobType3,
      jobType4,
      jobType5,
      jobType6
    ].join('');
    setJobType(combinedJobType);
  };

  // 社員顔写真取得
  const getFacePhotoData = useCallback(
    (userId: number) => {
      getFacePhoto(userId).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setFacePhotoFormat(data.file_format);
              setFacePhoto(
                data.data === ''
                  ? null
                  : `data:${data.file_format};base64,${data.data}`
              );
            }
          }
        }
      });
    },
    [changeLoggedInData, setOpen, setErrorMessage]
  );

  useEffect(() => {
    if (isEditMode && employeeId) {
      getFacePhotoData(employeeId);
    }
  }, [actionType, employeeId, getFacePhotoData]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setSelectedFile(file);
      setFacePhotoFormat('');
      saveFacePhoto(file);
    }
  };

  // 顔写真保存
  const saveFacePhoto = async (file: File) => {
    const reader = new FileReader();
    reader.onload = e => {
      if (e.target && typeof e.target.result === 'string') {
        setFacePhoto(e.target.result);
      }
    };
    reader.readAsDataURL(file);

    const data = new FormData();
    data.append('file_obj', file);

    try {
      const result = await addFacePhoto(employeeId, data);
      if (result === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else if (typeof result === 'string') {
        setErrorMessage(result);
        setOpen(true);
      } else if (result.error) {
        setErrorMessage(result.error);
        setOpen(true);
      } else {
        setErrorMessage(result.message);
        setOpenSuccess(true);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      setErrorMessage('画像のアップロードに失敗しました。');
      setOpen(true);
      getFacePhotoData(employeeId);
    }
  };

  // 顔写真削除
  const handleStampImageDelete = () => {
    deleteFacePhoto(employeeId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setFacePhoto(null);
            setFacePhotoFormat('');
          }
        }
      }
    });
  };

  // 郵便番号の前半部分（3桁）の入力を処理
  const handleFirstPartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 3);
    setFirstPart(value);
    setEmployeePostalCode(`${value}-${secondPart}`);
  };
  // 郵便番号の後半部分（4桁）の入力を処理
  const handleSecondPartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 4);
    setSecondPart(value);
    setEmployeePostalCode(`${firstPart}-${value}`);
  };

  useEffect(() => {
    if (employeePostalCode) {
      const [first, second] = employeePostalCode.split('-');
      setFirstPart(first || '');
      setSecondPart(second || '');
    }
  }, [employeePostalCode]);

  useEffect(() => {
    if (selectedDateOfBirthValue) {
      setAge(calculateAge(selectedDateOfBirthValue));
    } else {
      setAge('');
    }
  }, [selectedDateOfBirthValue]);

  useEffect(() => {
    if (selectedExpStartDateValue) {
      setYearsOfExperience(calculateYears(selectedExpStartDateValue));
    } else {
      setYearsOfExperience('');
    }
  }, [selectedExpStartDateValue]);

  useEffect(() => {
    if (selectedJoinDateValue) {
      setYearsOfService(calculateYears(selectedJoinDateValue));
    } else {
      setYearsOfService('');
    }
  }, [selectedJoinDateValue]);

  // パンくずリスト表示パターン(編集)
  let patternName =
    employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
      ? 'employee_masters_edit'
      : 'outside_partnerem_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName =
      employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
        ? 'employee_masters_create'
        : 'outside_partnerem_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} />

      {(loading && isEditMode) || userPermission === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight - 150
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Dialog
                open={openAlert}
                onClose={handleCloseAlert}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle id='alert-dialog-title'>
                  {'削除しますか？'}
                </DialogTitle>
                <DialogActions>
                  <Button onClick={handleCloseAlert} color='primary'>
                    キャンセル
                  </Button>
                  <Button
                    onClick={() => {
                      handleCloseAlert();
                      deleteEmployeeMasterDetailsById();
                    }}
                    color='primary'
                    autoFocus
                  >
                    削除
                  </Button>
                </DialogActions>
              </Dialog>
              {/* 業者検索モーダル */}
              <Dialog
                open={selectVendorModal}
                onClose={() => setSelectVendorModal(false)}
                scroll='paper'
                aria-labelledby='set_construct_title'
                aria-describedby='constructs'
              >
                <DialogTitle id='set_construct_title'>
                  <div>業者検索</div>
                  <div style={{ marginTop: 10 }}>
                    <input
                      placeholder='検索'
                      style={{
                        backgroundColor: '#F3F3F3',
                        borderRadius: 5,
                        width: '100%',
                        border: `1px solid ${mainColor}`,
                        padding: 5
                      }}
                      onChange={(e: any) => {
                        let filterArray = vendorDataSearch;
                        let searchResult = filterArray.filter(
                          (data: any) =>
                            data.name
                              .toUpperCase()
                              .includes(e.target.value.toUpperCase()) ||
                            data.furigana
                              .toUpperCase()
                              .includes(e.target.value.toUpperCase())
                        );
                        setVendorData(searchResult);
                      }}
                    />
                  </div>
                </DialogTitle>
                <DialogContent>
                  {vendorData.map((i: any) => (
                    <div
                      className='search-item'
                      onClick={() => {
                        setPartnerId(i.id);
                        setSelectVendorModal(false);
                      }}
                    >
                      {i.name}
                    </div>
                  ))}
                  {vendorData.length === 0 && (
                    <div style={{ color: '#FF6263', fontSize: 16 }}>
                      データがありません
                    </div>
                  )}
                </DialogContent>
              </Dialog>

              {employeeType == EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      marginBottom: 20,
                      color: '#758283',
                      backgroundColor: '#F5F5F5'
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      // 業者詳細に戻る
                      if (history.location.state.partnerId) {
                        history.goBack();
                      }
                      // 社外パートナー一覧に戻る
                      history.push('/employee-masters', {
                        employeeType: employeeType
                      });
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              )}

              <div>
                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    {employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE']
                      ? '社員基本情報'
                      : '社外パートナー基本情報'}
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: matches2 ? 'row' : 'column'
                  }}
                  className={classes.topList}
                >
                  <div
                    // 空アイテム
                    className='empty-list'
                    style={{ width: 15 }}
                  ></div>
                  <div
                    className='border2'
                    style={{
                      backgroundColor: '#F5F5F5',
                      borderTopColor: '#0099CB',
                      borderBottom: 'none'
                    }}
                  >
                    <div
                      className={classes.topBoxText}
                      style={{ color: '#0099CB' }}
                    >
                      基本情報
                    </div>
                  </div>
                  {employeeType !== EMPLOYEE_TYPE['OUTSIDE_PARTNER'] &&
                    isEmployeeAddInfo && (
                      <>
                        <div
                          onClick={() => {
                            if (
                              isEditMode &&
                              history.location.state?.employeeId
                            ) {
                              history.push(
                                `/employee-health-info/${employeeId}/edit`,
                                {
                                  employeeId: employeeId,
                                  actionType: 'edit',
                                  employeeType: employeeType
                                }
                              );
                            }
                          }}
                          className='border2'
                          style={{
                            cursor: isCreateMode ? 'not-allowed' : 'pointer',
                            opacity: isCreateMode ? 0.5 : 1
                          }}
                        >
                          <div className={classes.topBoxText}>健康状態</div>
                        </div>
                        <div
                          onClick={() => {
                            if (
                              isEditMode &&
                              history.location.state?.employeeId
                            ) {
                              history.push(
                                `/employee-emergency-info/${employeeId}/edit`,
                                {
                                  employeeId: employeeId,
                                  actionType: 'edit',
                                  employeeType: employeeType
                                }
                              );
                            }
                          }}
                          className='border2'
                          style={{
                            cursor: isCreateMode ? 'not-allowed' : 'pointer',
                            opacity: isCreateMode ? 0.5 : 1
                          }}
                        >
                          <div className={classes.topBoxText}>
                            緊急連絡先情報
                          </div>
                        </div>
                        <div
                          onClick={() => {
                            if (
                              isEditMode &&
                              history.location.state?.employeeId
                            ) {
                              history.push(
                                `/employee-credentials-info/${employeeId}/edit`,
                                {
                                  employeeId: employeeId,
                                  actionType: 'edit',
                                  employeeType: employeeType
                                }
                              );
                            }
                          }}
                          className='border2'
                          style={{
                            cursor: isCreateMode ? 'not-allowed' : 'pointer',
                            opacity: isCreateMode ? 0.5 : 1
                          }}
                        >
                          <div className={classes.topBoxText}>資格情報</div>
                        </div>
                      </>
                    )}
                </div>

                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    paddingBottom: 15,
                    marginBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <Divider
                      style={{
                        backgroundColor: '#CCCCCC',
                        marginLeft: 15,
                        marginTop: 15
                      }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          名前<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={name}
                            maxLength={20}
                            onChange={text => {
                              setName(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>ふりがな</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={furigana}
                            maxLength={50}
                            onChange={text => {
                              setFurigana(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          メールアドレス<span>*</span>
                        </div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={email}
                            maxLength={50}
                            onChange={text => {
                              setEmail(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>

                    {isCreateMode && (
                      <>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              パスワード<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                type='password'
                                value={password1}
                                onChange={text => {
                                  setPassword1(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>電話番号</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={phone}
                            maxLength={60}
                            onChange={text => {
                              setPhone(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    {employeeType !== EMPLOYEE_TYPE['OUTSIDE_PARTNER'] &&
                      isEmployeeAddInfo && (
                        <>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                郵便番号
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div
                                className={classes.inputContainer}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                              >
                                <input
                                  value={firstPart}
                                  onChange={handleFirstPartChange}
                                  className={classes.input}
                                  style={{ width: '3em', marginRight: '0.5em' }}
                                  maxLength={3}
                                  inputMode='numeric'
                                />
                                <span>-</span>
                                <input
                                  value={secondPart}
                                  onChange={handleSecondPartChange}
                                  className={classes.input}
                                  style={{ width: '4em', marginLeft: '0.5em' }}
                                  maxLength={4}
                                  inputMode='numeric'
                                />
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>住所</div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                <input
                                  value={employeeAddress}
                                  onChange={text => {
                                    setEmployeeAddress(text.target.value);
                                  }}
                                  className={classes.input}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    {employeeType == EMPLOYEE_TYPE['INSIDE_EMPLOYEE'] && (
                      <div className={classes.subContainer}>
                        <div className={classes.textMainContainer}>
                          <div className={classes.textContainer}>
                            権限<span>*</span>
                          </div>
                          <CustomTooltip
                            title={tooltipContents.permissionSettings}
                            placement='top'
                            interactive
                          >
                            <HelpIcon
                              style={{ color: 'white', marginLeft: 8 }}
                            />
                          </CustomTooltip>
                        </div>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainerSelectBox}>
                            <select
                              value={selectedEmployeeRole}
                              onChange={e => {
                                setSelectedEmployeeRole(
                                  parseInt(e.target.value)
                                );
                              }}
                              className={classes.selectBoxStyle}
                            >
                              <option value={0}>選択してください</option>
                              {employeeMasterRoles
                                .filter((i: any) => i.id !== 4)
                                .map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                    {employeeType == EMPLOYEE_TYPE['OUTSIDE_PARTNER'] && (
                      <div className={classes.subContainer}>
                        <div className={classes.textMainContainer}>
                          <div className={classes.textContainer}>
                            業者
                            <Button
                              style={{
                                padding: '2px 6px',
                                marginLeft: 16,
                                color: '#758283',
                                backgroundColor: '#F5F5F5'
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<SearchIcon />}
                              onClick={() => setSelectVendorModal(true)}
                            >
                              検索
                            </Button>
                          </div>
                        </div>
                        <div className={classes.inputMainContainer}>
                          <div className={classes.inputContainerSelectBox}>
                            <select
                              value={partnerId}
                              onChange={text => {
                                setPartnerId(parseInt(text.target.value));
                              }}
                              className={classes.selectBoxStyle}
                              name='cars'
                              id='cars'
                              form='carform'
                            >
                              <option value={0}>選択してください</option>
                              {vendorData.map((i: any) => (
                                <option value={i.id}>{i.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    )}

                    {employeeType !== EMPLOYEE_TYPE['OUTSIDE_PARTNER'] &&
                      isEmployeeAddInfo && (
                        <>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                社員ID
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                <input
                                  value={employeeNum || ''}
                                  onChange={e => {
                                    const inputValue = e.target.value;
                                    setEmployeeNum(inputValue);
                                  }}
                                  className={classes.input}
                                  type='text'
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </Grid>
                  {employeeType !== EMPLOYEE_TYPE['OUTSIDE_PARTNER'] &&
                    isEmployeeAddInfo && (
                      <>
                        <Grid item xs={matches2 ? 4 : 12}>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15,
                              marginTop: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                所属会社
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                <input
                                  value={othersDepartment}
                                  onChange={text => {
                                    setOthersDepartment(text.target.value);
                                  }}
                                  className={classes.input}
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                生年月日
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div
                                style={{
                                  marginLeft: 10,
                                  marginRight: 15,
                                  backgroundColor: '#FFFFFF',
                                  height: 42,
                                  paddingBottom: 5,
                                  paddingLeft: 5,
                                  width: '100%'
                                }}
                                className={'select-div-div'}
                              >
                                <DatePickerInput
                                  date={selectedDateOfBirthValue}
                                  onChange={handleDateOfBirth}
                                  id={'birth_date'}
                                  emptyLabel={'生年月日'}
                                />
                              </div>
                            </div>
                          </div>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>年齢</div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputMainContainer}>
                                <div className={classes.inputContainer}>
                                  <span className={classes.input}>{age}歳</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                経験開始年月日
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div
                                style={{
                                  marginLeft: 10,
                                  marginRight: 15,
                                  backgroundColor: '#FFFFFF',
                                  height: 42,
                                  paddingBottom: 5,
                                  paddingLeft: 5,
                                  width: '100%'
                                }}
                                className={'select-div-div'}
                              >
                                <DatePickerInput
                                  date={selectedExpStartDateValue}
                                  onChange={handleExperienceStartDate}
                                  id={'exp_start_date'}
                                  emptyLabel={'開始日'}
                                />
                              </div>
                            </div>
                          </div>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                経験年数
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                <span className={classes.input}>
                                  {yearsOfExperience}年
                                </span>
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                入社年月日
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div
                                style={{
                                  marginLeft: 10,
                                  marginRight: 15,
                                  backgroundColor: '#FFFFFF',
                                  height: 42,
                                  paddingBottom: 5,
                                  paddingLeft: 5,
                                  width: '100%'
                                }}
                                className={'select-div-div'}
                              >
                                <DatePickerInput
                                  date={selectedJoinDateValue}
                                  onChange={handleJoinDate}
                                  id={'join_date'}
                                  emptyLabel={'日付を選択'}
                                />
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                在籍年数
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                <span className={classes.input}>
                                  {yearsOfService}年
                                </span>
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                退職年月日
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div
                                style={{
                                  marginLeft: 10,
                                  marginRight: 15,
                                  backgroundColor: '#FFFFFF',
                                  height: 42,
                                  paddingBottom: 5,
                                  paddingLeft: 5,
                                  width: '100%'
                                }}
                                className={'select-div-div'}
                              >
                                <DatePickerInput
                                  date={selectedRetirementDateValue}
                                  onChange={handleRetirementDate}
                                  id={'retirement_date'}
                                  emptyLabel={'日付を選択'}
                                />
                              </div>
                            </div>
                          </div>
                        </Grid>

                        <Grid item xs={matches2 ? 4 : 12}>
                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15,
                              marginTop: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.sealtextContainer}>
                              <div className={classes.textContainer}>
                                顔写真
                              </div>
                            </div>
                            <div className={classes.sealImage}>
                              <div className={classes.inputContainer}>
                                <div
                                  style={{
                                    width: '220px',
                                    height: '130px',
                                    marginRight: '20px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '4px'
                                  }}
                                >
                                  {facePhoto ? (
                                    <>
                                      <img
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'contain'
                                        }}
                                        src={facePhoto}
                                        alt='employee-face'
                                      />
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: '10px'
                                        }}
                                      >
                                        <input
                                          accept='image/*'
                                          style={{ display: 'none' }}
                                          id='raised-button-file'
                                          type='file'
                                          onChange={handleFileChange}
                                        />
                                        <label htmlFor='raised-button-file'>
                                          <Button
                                            component='span'
                                            style={{
                                              color: '#758283',
                                              backgroundColor: '#F5F5F5',
                                              width: '100px'
                                            }}
                                            variant='contained'
                                            color='secondary'
                                            startIcon={<EditIcon />}
                                          >
                                            編集
                                          </Button>
                                        </label>
                                        <Button
                                          style={{
                                            color: '#758283',
                                            backgroundColor: '#F5F5F5',
                                            width: '100px'
                                          }}
                                          variant='contained'
                                          color='secondary'
                                          onClick={() =>
                                            handleStampImageDelete()
                                          }
                                          startIcon={<DeleteIcon />}
                                        >
                                          削除
                                        </Button>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          height: '130px',
                                          width: '150px',
                                          backgroundColor: 'gray',
                                          marginRight: '20px',
                                          borderRadius: '4px'
                                        }}
                                      >
                                        <div style={{ color: '#FFFFFF' }}>
                                          No Image
                                        </div>
                                      </div>
                                      <div>
                                        <label htmlFor='raised-button-file'>
                                          <Button
                                            component='span'
                                            style={{
                                              color:
                                                actionType === 'create'
                                                  ? '#B0B0B0'
                                                  : '#758283',
                                              backgroundColor: '#F5F5F5',
                                              width: '100px',
                                              boxShadow:
                                                '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                              cursor:
                                                actionType === 'create'
                                                  ? 'not-allowed'
                                                  : 'pointer',
                                              opacity:
                                                actionType === 'create'
                                                  ? 0.5
                                                  : 1
                                            }}
                                            variant='contained'
                                            color='secondary'
                                            startIcon={<EditIcon />}
                                            disabled={actionType === 'create'}
                                          >
                                            編集
                                          </Button>
                                        </label>
                                        <input
                                          accept='image/*'
                                          style={{ display: 'none' }}
                                          id='raised-button-file'
                                          type='file'
                                          onChange={handleFileChange}
                                          disabled={actionType === 'create'}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                職種記号
                              </div>
                            </div>
                            <div className={classes.inputJobTypeMainContainer}>
                              <div className={classes.inputJobTypeContainer}>
                                {[
                                  jobType1,
                                  jobType2,
                                  jobType3,
                                  jobType4,
                                  jobType5,
                                  jobType6
                                ].map((value, index) => (
                                  <input
                                    key={index}
                                    value={value}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      const newValue = e.target.value;
                                      const setter = [
                                        setJobType1,
                                        setJobType2,
                                        setJobType3,
                                        setJobType4,
                                        setJobType5,
                                        setJobType6
                                      ][index];
                                      setter(newValue);
                                    }}
                                    onCompositionEnd={(
                                      e: React.CompositionEvent<HTMLInputElement>
                                    ) => {
                                      const newValue = e.currentTarget.value;
                                      const setter = [
                                        setJobType1,
                                        setJobType2,
                                        setJobType3,
                                        setJobType4,
                                        setJobType5,
                                        setJobType6
                                      ][index];
                                      setter(newValue.charAt(0));
                                      updateJobType();
                                    }}
                                    className={classes.inputJobType}
                                    maxLength={1}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                扶養家族
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                  }}
                                >
                                  <div
                                    onClick={() => setDependentFamily(true)}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      padding: 8,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <div className='checkbox'>
                                      {dependentFamily === true && (
                                        <div className='dot' />
                                      )}
                                    </div>
                                    <div
                                      style={{ fontSize: 16, marginLeft: 5 }}
                                    >
                                      有
                                    </div>
                                  </div>

                                  <div
                                    onClick={() => setDependentFamily(false)}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      padding: 8,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <div className='checkbox'>
                                      {dependentFamily === false && (
                                        <div className='dot' />
                                      )}
                                    </div>
                                    <div
                                      style={{ fontSize: 16, marginLeft: 5 }}
                                    >
                                      無
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                扶養人数
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainer}>
                                {dependentFamily ? (
                                  <input
                                    value={numOfDependents}
                                    onChange={e => {
                                      const inputValue = e.target.value;
                                      // 空文字または数値形式の文字列であれば状態を更新
                                      if (
                                        inputValue === '' ||
                                        (/^\d*$/.test(inputValue) &&
                                          inputValue.length <= 2)
                                      ) {
                                        setNumOfDependents(inputValue);
                                      }
                                    }}
                                    className={classes.input}
                                    type='number' // 入力をそのまま保持したい場合、type="text"に変更
                                  />
                                ) : (
                                  <span className={classes.input}>0人</span>
                                )}
                              </div>
                            </div>
                          </div>

                          <Divider
                            style={{
                              backgroundColor: '#CCCCCC',
                              marginLeft: 15
                            }}
                          />
                        </Grid>
                      </>
                    )}
                </Grid>

                <div
                  className='table-top-container-customer'
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      padding: 15,
                      paddingBottom: 0,
                      fontSize: 24
                    }}
                  >
                    {'ステータス'}
                  </div>
                </div>
                <Grid
                  container
                  style={{ backgroundColor: '#FFFFFF', paddingBottom: 5 }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div
                      className={classes.subContainer}
                      style={{ zIndex: 100 }}
                    >
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>
                          社員グループ名
                        </div>
                      </div>
                      <div
                        className={classes.inputMainContainer}
                        style={{ overflow: 'hidden' }}
                      >
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 13,
                            width: '100%'
                          }}
                          className='select-div-mutiselect'
                        >
                          <FormControl
                            style={{
                              width: selectedGroupId.length > 2 ? 250 : '100%',
                              paddingLeft: 5
                            }}
                          >
                            <Select
                              multiple
                              displayEmpty
                              value={selectedGroupIdNames}
                              style={{
                                width: selectedGroupId.length > 2 ? 250 : '100%'
                              }}
                              onChange={handleChange}
                              disableUnderline
                              renderValue={(selected: any) => {
                                if ((selected as string[]).length === 0) {
                                  return <em>選択してください</em>;
                                }
                                return (selected as string[]).join(', ');
                              }}
                              inputProps={{ 'aria-label': 'Without label' }}
                            >
                              {/* <MenuItem disabled value={[]}>
                                <em>選択してください</em>
                              </MenuItem> */}
                              {companyGroups.map((i: any, k) => (
                                <MenuItem key={i.id} value={i.name}>
                                  <Checkbox
                                    style={{ color: mainColor }}
                                    checked={
                                      selectedGroupIdNames.indexOf(i.name) > -1
                                    }
                                  />
                                  <ListItemText primary={i.name} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div
                        className={classes.textMainContainer}
                        style={{ height: 132 }}
                      >
                        <div>
                          <div className={classes.textContainer}>
                            在籍 or 退職 or 契約<span>*</span>
                          </div>
                          <CustomTooltip
                            title={tooltipContents.employeeRetirement}
                            placement='bottom'
                          >
                            <HelpIcon
                              style={{ color: 'white', marginLeft: 8 }}
                            />
                          </CustomTooltip>
                        </div>
                      </div>
                      <div
                        className={classes.inputMainContainer}
                        style={{ height: 132 }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                          }}
                        >
                          <div
                            onClick={() => {
                              setEnrollmentStatus(1);
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: 8
                            }}
                          >
                            <div className='checkbox'>
                              {enrollmentStatus === 1 && (
                                <div className='dot' />
                              )}
                            </div>
                            <div style={{ fontSize: 14, marginLeft: 5 }}>
                              在籍
                            </div>
                          </div>

                          <div
                            onClick={() => {
                              setEnrollmentStatus(2);
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: 8
                            }}
                          >
                            <div className='checkbox'>
                              {enrollmentStatus === 2 && (
                                <div className='dot' />
                              )}
                            </div>
                            <div style={{ fontSize: 14, marginLeft: 5 }}>
                              退職
                            </div>
                          </div>
                          <div
                            onClick={() => {
                              setEnrollmentStatus(3);
                            }}
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: 8
                            }}
                          >
                            <div className='checkbox'>
                              {enrollmentStatus === 3 && (
                                <div className='dot' />
                              )}
                            </div>
                            <div style={{ fontSize: 14, marginLeft: 5 }}>
                              契約
                            </div>
                          </div>
                          {isEmployeeAddInfo && (
                            <div
                              onClick={() => {
                                setEnrollmentStatus(4);
                              }}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: 8
                              }}
                            >
                              <div className='checkbox'>
                                {enrollmentStatus === 4 && (
                                  <div className='dot' />
                                )}
                              </div>
                              <div style={{ fontSize: 14, marginLeft: 5 }}>
                                運用管理
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>部署</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={department}
                            maxLength={20}
                            onChange={text => {
                              setDepartment(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>職種</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={occupation}
                            maxLength={20}
                            onChange={text => {
                              setOccupation(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>役職</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div className={classes.inputContainer}>
                          <input
                            value={position}
                            maxLength={20}
                            onChange={text => {
                              setPosition(text.target.value);
                            }}
                            className={classes.input}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{
                        backgroundColor: '#CCCCCC',
                        marginLeft: 15,
                        width: '32%'
                      }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer1}>
                        <div className={classes.textContainer1}>備考</div>
                      </div>
                      <div className={classes.inputMainContainer1}>
                        <div className={classes.inputContainer}>
                          <textarea
                            value={remarks}
                            maxLength={225}
                            onChange={text => {
                              setRemarks(text.target.value);
                            }}
                            className={classes.input1}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                  </Grid>
                </Grid>
                <div style={{ height: 10, backgroundColor: '#FFFFFF' }}></div>
              </div>
            </div>
            <div style={{ height: 80 }} />
          </div>

          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-around',
              padding: 20
            }}
          >
            <div style={{ flex: 1 }} />
            <div
              style={{
                flex: 1,
                textAlign: 'center'
              }}
            >
              <Button
                onClick={() => {
                  if (isEditMode) {
                    setIsEdit(true);
                    editEmployeeMasterDetails();
                  } else {
                    setIsEdit(false);
                    saveEmployeeMasterDetails();
                  }
                }}
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
              >
                保存
              </Button>
            </div>
            <div
              style={{
                flex: 1,
                textAlign: 'right',
                paddingRight: 20
              }}
            >
              {isEditMode && (
                <div>
                  <Button
                    style={{
                      marginRight: 10,
                      color: '#758283',
                      backgroundColor: '#F5F5F5',
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={handleClickOpenAlert}
                    startIcon={<DeleteIcon />}
                  >
                    削除
                  </Button>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};
